import { render, staticRenderFns } from "./UsedCardboardBoxes.vue?vue&type=template&id=08e539d1&scoped=true&"
import script from "./UsedCardboardBoxes.vue?vue&type=script&lang=js&"
export * from "./UsedCardboardBoxes.vue?vue&type=script&lang=js&"
import style0 from "./UsedCardboardBoxes.vue?vue&type=style&index=0&id=08e539d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e539d1",
  null
  
)

export default component.exports